/* src/app/warehousing/pages/warehouses-edit/warehouses-edit.component.scss */
/*# sourceMappingURL=warehouses-edit.component.css.map */
